import type { StepViewMode } from './player-session-card.utils';

export const stepViewModeCache = new Map<string, StepViewMode>();
export const activeStepIdxCache = new Map<string, number | null>();
export const activeBadgeCache = new Map<string, { name: string; label: string } | null>();
export const activeGroupCache = new Map<string, { key: string; label: string } | null>();

let resetVersion = 0;
const listeners = new Set<() => void>();

/**
 * External store used by `usePlayerSessionCard` to reset per-card UI state (step view mode)
 * whenever the underlying list query result changes (search, filter, sort, pagination).
 */
export const overviewResetStore = {
  subscribe(callback: () => void) {
    listeners.add(callback);
    return () => {
      listeners.delete(callback);
    };
  },
  getSnapshot() {
    return resetVersion;
  },
  reset() {
    stepViewModeCache.clear();
    activeStepIdxCache.clear();
    activeBadgeCache.clear();
    activeGroupCache.clear();
    resetVersion += 1;
    listeners.forEach(listener => listener());
  },
};
